import React from 'react'
import { createMemoryHistory } from 'history'
import { Router as DefaultRouter } from 'react-router-dom'

export const history = createMemoryHistory()

export const Router: React.FC<{ children?: React.ReactNode }> = props => {
  return <DefaultRouter {...props} history={history} />
}
